import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ROUTES } from '../config/appConfig';
import { companyInfo } from '../config/companyConfig';
import '../styles/Footer.css';

const footerServices = [
  'Same-day Delivery',
  'Courier Services',
  'Bulk Shipping',
];

const AppFooter = () => {
  return (
    <footer className="footer-section">
      <Container>
        <Row className="g-4 mb-4 footer-top-row">
          <Col md={6} lg={4}>
            <h6>About</h6>
            <p className="footer-text">{companyInfo.tagline}</p>
          </Col>
          <Col md={6} lg={4}>
            <h6>Services</h6>
            <ul className="footer-links">
              {footerServices.map((service) => (
                <li key={service}>
                  <Link to={ROUTES.home}>{service}</Link>
                </li>
              ))}
            </ul>
          </Col>
          <Col md={6} lg={4}>
            <h6>Contact</h6>
            <p className="footer-text">{companyInfo.phone}</p>
            <p className="footer-text">{companyInfo.email}</p>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col className="text-center">
            <p className="footer-bottom">&copy; 2026 {companyInfo.name}. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default AppFooter;
